// lingland-frontend/src/pages/QuotePage.js (POPRAWIONA WERSJA)
/* eslint-disable no-unused-vars */
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import SEO from '../components/SEO';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import QuoteForm from '../components/forms/QuoteForm';
import { FileText, CheckSquare, Send, Cpu } from 'lucide-react';
import './QuotePage.css';

const MAX_FILES = 5;
const MAX_TOTAL_SIZE_MB = 50;

function QuotePage() {
    const { t } = useTranslation();
    const [headerRef, isHeaderVisible] = useIntersectionObserver();
    const [infoRef, isInfoVisible] = useIntersectionObserver();
    const [formSectionRef, isFormSectionVisible] = useIntersectionObserver();

    return (
        <>
            <SEO
                title={t('quote_header_title')}
                description={t('quote_header_subtitle', {maxFiles: MAX_FILES, maxSize: MAX_TOTAL_SIZE_MB})}
                url="/wycena"
            />
            <section ref={headerRef} className={`page-header-section section-bg-white animate-on-scroll ${isHeaderVisible ? 'is-visible' : ''}`}>
                <div className="container text-center">
                    <h1>{t('quote_header_title')}</h1>
                    <p className="subtitle">
                        {t('quote_header_subtitle', {maxFiles: MAX_FILES, maxSize: MAX_TOTAL_SIZE_MB})} <br />
                        <span className="auto-quote-notice">
                            <Trans i18nKey="quote_header_notice">
                                Dla plików tekstowych (<strong>DOC, DOCX, PDF, TXT</strong>) nasz system spróbuje automatycznie przeanalizować zawartość, aby przyspieszyć proces wyceny. Akceptujemy również pliki graficzne (<strong>JPG, JPEG, PNG</strong>).
                            </Trans>
                        </span>
                    </p>
                </div>
            </section>

            <section ref={infoRef} className={`quote-info-section section-bg-light-gray animate-on-scroll ${isInfoVisible ? 'is-visible' : ''}`}>
                <div className="container">
                    <div className="info-grid">
                        <div className="info-item">
                            <FileText size={40} strokeWidth={1.5} />
                            <h4>{t('quote_info1_title')}</h4>
                            <p>
                                <Trans i18nKey="quote_info1_desc" values={{ maxFiles: MAX_FILES }} 
                                    components={{ 
                                        1: <strong />,
                                        5: <strong />,
                                        9: <Link to="/kontakt" /> 
                                    }}
                                />
                            </p>
                        </div>
                        <div className="info-item">
                            <CheckSquare size={40} strokeWidth={1.5} />
                            <h4>{t('quote_info2_title')}</h4>
                            <p>{t('quote_info2_desc')}</p>
                        </div>
                        <div className="info-item">
                             <Send size={40} strokeWidth={1.5} />
                            <h4>{t('quote_info3_title')}</h4>
                            <p>{t('quote_info3_desc')}</p>
                        </div>
                    </div>
                </div>
            </section>

            <section ref={formSectionRef} className={`quote-form-section section-bg-white animate-on-scroll ${isFormSectionVisible ? 'is-visible' : ''}`}>
                <div className="container">
                     <h2 className="text-center form-wrapper-title">{t('quote_form_title')}</h2>
                     <div className="quote-form-wrapper">
                         <QuoteForm />
                     </div>
                 </div>
            </section>
        </>
    );
}

export default QuotePage;